// extracted by mini-css-extract-plugin
module.exports = {"item":"FriendListItem_item__3zOG5","status":"FriendListItem_status__X6dWu","statusOnline":"FriendListItem_statusOnline__2kwgS","statusOfline":"FriendListItem_statusOfline__OsnAF"};